/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2FeatureFlag/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2FeatureFlag({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2FeatureFlag",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2FeatureFlag.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-G4zro': alignSelf,'--mt-2-G4zro': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-G4zro': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-G4zro': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-G4zro': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-G4zro': opacity,'--w-10-G4zro': typeof width === 'number' ? `${width}px` : width,'--h-11-G4zro': typeof height === 'number' ? `${height}px` : height,'--f-12-G4zro': fill,'--a-7-G4zro': isAnimated ? animation : "none",'--sd-8-G4zro': isAnimated ? strokeDashoffset : 0,'--sd-9-G4zro': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2FeatureFlag.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M6.286 2a4.286 4.286 0 000 8.571h11.428a4.286 4.286 0 100-8.571H6.286zm0 11.429a4.286 4.286 0 000 8.571h11.428a4.286 4.286 0 100-8.571H6.286zm12.857-7.144a2.143 2.143 0 11-4.286 0 2.143 2.143 0 014.286 0zM7 19.856a2.143 2.143 0 100-4.285 2.143 2.143 0 000 4.285z"
 style={{'--f-12-G4zro': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}